var dom = require('./dom')
var getOffset = require('./get-offset')
var animate = require('./animate')

var curAnimation = null

export default function scrollTo(elem, options) {
	var html = document.documentElement
	var body = dom.byTag('body')[0]
	var sourceScroll = html.scrollTop || body.scrollTop
	var targetScroll = getOffset(elem).top

	if(options.speed) {
		var dist = Math.abs(sourceScroll - targetScroll)

		if(typeof options.speed === 'function') {
			options.duration = options.speed(dist)
		} else {
			var speed = parseFloat(options.speed)
			if(speed < 0) {
				speed = 0
			}
			options.duration = speed / 1000 * dist
		}
	}

	if(curAnimation !== null) {
		curAnimation.cancel()
	}

	curAnimation = animate(
		sourceScroll,
		targetScroll,
		y => {
			html.scrollTop = y
			body.scrollTop = y
		},
		options
	)
}
